import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isValidEmail } from 'src/app/extensions/utilities';

@Component({
  selector: 'app-invalid-account',
  templateUrl: './invalid-account.component.html',
  styleUrls: ['./invalid-account.component.scss'],
  standalone: false,
})
export class InvalidAccountComponent implements OnInit {
  isSubtenant: boolean = false;
  partnerName: string = 'partnerName';
  phoneNumber: string = 'phoneNumber';
  email: string = 'email';
  emailAccount: string;
  isValidEmailAccount: boolean;

  constructor(
    private _globalService: GlobalService,
    private _oauthService: OAuthService
  ) {}

  ngOnInit(): void {
    this.emailAccount = this._globalService.user.email;
    this.isValidEmailAccount = isValidEmail(this.emailAccount);
  }

  public logout() {
    this._oauthService.logOut();
  }
}
